import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor, productName } from '../data/content';
import { checkoutFeatures, offerDescription, pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
type PricingProps = {
  /** Only the primary offer section carries the #offer anchor id */
  id?: string;
  titleId?: string;
};
export function Pricing({
  id,
  titleId = 'offer-title'
}: PricingProps) {
  return <section id={id} className="scroll-mt-4 bg-teal-950 px-4 py-12 md:py-16" aria-labelledby={titleId} data-id="element-168" data-mp="kadvpajv4pub">
      <div className="mx-auto max-w-xl" data-id="element-169" data-mp="6al6jjnzihog">
        <div className="text-center" data-id="element-170" data-mp="acq2wq5thses">
          <p className="text-[11px] font-black uppercase tracking-[.2em] text-amber-300 md:text-xs" data-id="element-171" data-mp="aboku1qdw5nk">
            Special launch offer
          </p>
          <h2 id={titleId} className="mt-2 text-2xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-172" data-mp="2r3q0v0m9xej3">
            {productName}
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-white/80" data-id="element-173" data-mp="2fodpzbzuk2qo">{offerDescription}</p>
        </div>

        <article className="mt-8 rounded-3xl border-4 border-amber-400 bg-white p-6 shadow-2xl md:p-8" data-id="element-174" data-mp="2aqc6wr2f83f7">
          <OfferLink href={offerAnchor} className="mx-auto max-w-[260px]" label={`${productName} offer`} data-id="element-175" data-mp="2om678lp4pkgp">
            <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-176" data-mp="2korxmsxjdao6" />
          </OfferLink>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-177" data-mp="38b8ag8wnz245">
            Everything included:
          </p>
          <ul className="mx-auto mt-3 flex w-fit flex-col gap-2" data-id="element-178" data-mp="3hcy0baawdszt">
            {checkoutFeatures.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-teal-950" data-id="element-179" data-mp="3ce4tu1u13295">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-700" aria-hidden="true" data-id="element-180" data-mp="2a0p2xflf5o0m" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-center text-sm" data-id="element-181" data-mp="2exfi80pegfkz">
            <span className="font-semibold text-slate-600" data-id="element-182" data-mp="2j02i8ow856t9">Bonus reference value: </span>
            <span className="font-bold text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-183" data-mp="2ns3q7ymd0bdh">
              ${pricing.bonusValue} USD
            </span>
            <span className="ml-2 font-black uppercase text-teal-700" data-id="element-184" data-mp="2stax7vgoh6j3">Free</span>
          </p>

          <p className="mt-6 text-center text-xs font-black uppercase tracking-wide text-teal-700" data-id="element-185" data-mp="2xs49xlo54ti7">Instant access:</p>
          <p className="mt-1 text-center text-4xl font-black text-teal-950" data-id="element-186" data-mp="36qpoz6uelqe8">
            ${pricing.price} <span className="text-base font-bold text-slate-500" data-id="element-187" data-mp="18b3aisuxqb09">USD</span>
          </p>
          <div className="mt-4" data-id="element-188" data-mp="18dg09s6xppnv">
            <Button href={checkoutUrl} size="lg" fullWidth subtext={`One-time payment of $${pricing.price} USD`} data-id="element-189" data-mp="1cc5bbe4i2v4c">
              Yes! I want the complete rehabilitation bundle
            </Button>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-extrabold uppercase text-slate-600" data-id="element-190" data-mp="1027d6dbp8dju">
            <li className="flex items-center gap-1.5" data-id="element-191" data-mp="v3m9g3x8nbqn">
              <ZapIcon className="h-3.5 w-3.5 text-teal-700" aria-hidden="true" data-id="element-192" data-mp="r2apadx4vipu" /> Instant Digital Delivery
            </li>
            <li className="flex items-center gap-1.5" data-id="element-193" data-mp="1nqqjinb6ug9a">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-teal-700" aria-hidden="true" data-id="element-194" data-mp="1isxbdoqbrc6d" /> 7-Day Guarantee
            </li>
            <li className="flex items-center gap-1.5" data-id="element-195" data-mp="1eqk9xcim20fe">
              <LockIcon className="h-3.5 w-3.5 text-teal-700" aria-hidden="true" data-id="element-196" data-mp="1etg3yprc84yk" /> Secure Payment
            </li>
          </ul>
        </article>
      </div>
    </section>;
}